import { render, staticRenderFns } from "./IncidencesModal.vue?vue&type=template&id=3d4ee184&scoped=true"
import script from "./IncidencesModal.vue?vue&type=script&lang=js"
export * from "./IncidencesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4ee184",
  null
  
)

export default component.exports